export const INICIALIZAR_FORM = 'INICIALIZAR_FORM';
export const CARGAR_MENU = 'CARGAR_MENU';
export const VISUALIZAR_LOADING = 'VISUALIZAR_LOADING';
export const VISUALIZAR_MENU = 'VISUALIZAR_MENU';
export const LOAD_VALORESSESIONFORM = 'LOAD_VALORESSESIONFORM';
export const RESET_VALORESSESIONFORM = 'RESET_VALORESSESIONFORM';
export const VISUALIZAR_ALERTA = 'VISUALIZAR_ALERTA';
export const SELECCIONAR_NUMCOMPROBANTE = 'SELECCIONAR_NUMCOMPROBANTE';
export const SELECCIONAR_NUMCOMPROBANTEALTERNO = 'SELECCIONAR_NUMCOMPROBANTEALTERNO';